import { render, staticRenderFns } from "./Works.vue?vue&type=template&id=4e0cdb9c&scoped=true&"
import script from "./Works.vue?vue&type=script&lang=js&"
export * from "./Works.vue?vue&type=script&lang=js&"
import style0 from "./Works.vue?vue&type=style&index=0&id=4e0cdb9c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0cdb9c",
  null
  
)

export default component.exports